/* --------------------------------------------------------------------------
   Applikationstillstånd
   -------------------------------------------------------------------------- */
export const state = {
  receipts: [],     // normaliserade kvitton
  bounds: null,     // {min, max, months[]}
  view: [],         // kvitton efter filter
  stats: null,      // beräknad analys
  prev: null,       // motsvarande analys för jämförelseperioden
  scoped: [],       // kvitton efter butik/kassa/kassör och radurval, hela tidsspannet
  lineFiltered: false, // artikelgrupp eller leverantör vald: kvittona är insnävade
  series: [],       // statistik per tidsperiod för utvecklingsvyn
  grain: 'month',   // dag, vecka eller månad
  metric: 'revenue',
  compareMode: 'prev',
  charts: {},
  lineSelects: {},  // flervalen för artikelgrupp och leverantör, MultiSelect
  // Kortterminalens kvitton i filen: any om det finns något alls, contactless
  // och pin om filen har sådana markeringar. Gäller hela filen, inte urvalet,
  // så att kortöversikten inte byter utseende med urvalet.
  terminal: {any:false, contactless:false, pin:false},
  // Butiker: etikett per nummer, och om filen har fler än en. Med en enda
  // butik visas inget om butiker alls.
  storeLabels: new Map(),
  multiStore: false,
  // Inköpspris finns på någon artikel i filen. Saknas det på alla går
  // bruttovinst och marginal inte att räkna fram, och de visas inte.
  hasCost: true,
  scopeSelects: {}, // flervalen för butik, kassa och kassör, MultiSelect
  trendSpan: 'file',   // utvecklingsvyn: hela filen eller den valda perioden
  dayTime: '',      // valda veckodagar och klockslag i ord, '' utan urval
  weekdays: [],     // valda veckodagar, måndag 0
  productSort: {key:'revenue', dir:'desc'},
  marginSort:  {key:'profit',  dir:'desc'},
  productQuery: '',
  // Kunder i lojalitetsprogrammet: finns de i filen, och senaste namnet per
  // kundnummer. Utan kunder visas varken kundurvalet eller fliken Kunder.
  hasCustomers: false,
  hasBonus: false,
  customerNames: new Map(),
  customerSort: {key:'revenue', dir:'desc'},
  customerQuery: '',
  // Kampanjer och rabatt på artikel i filen. Utan båda visas inte fliken.
  hasPromos: false,
  hasDiscounts: false,
  discSort: {key:'discount', dir:'desc'},
  basketKey: ''     // artikeln i Köps ofta tillsammans
};
